import Vue from 'vue'

export default {
    resetStateMutation(state) {
        Vue.set(state, "patientWaitingTableIsShow", true);
        Vue.set(state, "patientAttendanceTableIsShow", false);
        Vue.set(state, "patientAttendanceDetailsIsShow", false);
        Vue.set(state, "occupationHealthDoctorAppointmentIsShow", false);
    },
    showPatientWaitingTable(state) {
        state.patientWaitingTableIsShow = true;
        state.patientAttendanceTableIsShow = false;
        state.patientWaitingDisbandIsShow = false;
        state.patientAttendanceDetailsIsShow = false;
        state.occupationHealthDoctorAppointmentIsShow = false;
    },
    showOccupationHealthDoctorAppointment(state) {
        state.patientWaitingTableIsShow = false;
        state.patientAttendanceTableIsShow = false;
        state.patientWaitingDisbandIsShow = false;
        state.patientAttendanceDetailsIsShow = false;
        state.occupationHealthDoctorAppointmentIsShow = true;
    },
    showPatientAttendanceTable(state) {
        state.patientWaitingTableIsShow = false;
        state.patientAttendanceTableIsShow = true;
        state.patientWaitingDisbandIsShow = false;
        state.patientAttendanceDetailsIsShow = false;
        state.occupationHealthDoctorAppointmentIsShow = false;
    },
    showPatientAttendanceDetails(state) {
        state.patientWaitingTableIsShow = false;
        state.patientAttendanceTableIsShow = false;
        state.patientWaitingDisbandIsShow = false;
        state.patientAttendanceDetailsIsShow = true;
        state.occupationHealthDoctorAppointmentIsShow = false;
    }
}
